import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import Buttons from "./pagination-buttons";

const safeNumber = (value, defaultValue) => {
  return Number.isNaN(value) ? defaultValue : value;
};

const Footer = ({
  page,
  totalPages,
  rowsPerPage,
  selectedRowsPerPage,
  setSelectedRowsPerPage,
  setPage
}) => {
  const [currentPage, setCurrentPage] = useState(page);
  useEffect(() => {
    setCurrentPage(page);
  }, [page]);
  useEffect(() => {
    if (totalPages < page && totalPages > 0) {
      setPage(safeNumber(totalPages, page));
    }
    // pasar la funcion produce un bucle infinito
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [totalPages, page]);
  return (
    <div className="table-footer">
      <div className="row">
        <div className="col align-self-start">
          <span>
            Página{" "}
            <input
              className="page-input"
              value={currentPage}
              onChange={event => setCurrentPage(event.target.value)}
              onBlur={() => setPage(safeNumber(currentPage, page))}
            />{" "}
            de {totalPages}
          </span>
        </div>
        <div className="col align-self-center">
          <Buttons page={page} totalPages={totalPages} setPage={setPage} />
        </div>
        <div className="col align-self-end">
          <span>
            Mostrar{" "}
            <select
              className="form-control"
              value={
                rowsPerPage.includes(selectedRowsPerPage) ? selectedRowsPerPage : rowsPerPage[0]
              }
              onChange={event => setSelectedRowsPerPage(event.target.value)}
            >
              {rowsPerPage.map(option => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>{" "}
            registros
          </span>
        </div>
      </div>
    </div>
  );
};

Footer.propTypes = {
  page: PropTypes.number,
  totalPages: PropTypes.number,
  rowsPerPage: PropTypes.arrayOf(PropTypes.number),
  selectedRowsPerPage: PropTypes.number,
  setSelectedRowsPerPage: PropTypes.func,
  setPage: PropTypes.func
};

Footer.defaultProps = {
  page: 1,
  totalPages: 1,
  rowsPerPage: [5, 10, 20],
  selectedRowsPerPage: 5,
  setSelectedRowsPerPage: () => {},
  setPage: () => {}
};

export default Footer;
